import { Box, Button, Typography } from '@mui/material';
import Alerta from '../Alerta.tsx/Alerta';
import LogoBosch from 'assets/logo/LogoBosch.png';
import { UsuarioDTO } from 'utils/models/types';
import { useNavigate } from 'react-router-dom';
import { anchoMaxForms } from 'utils/constants';

interface PantallaExitoProps {
  titulo?: string;
  mensaje: string;
  subMensaje?: string;
  onVolver: () => void;
}

const PantallaExito = ({ titulo, mensaje, subMensaje, onVolver }: PantallaExitoProps) => {
  const navigate = useNavigate();
  const usuarioJSON = localStorage.getItem('usuario');
  const usuario: UsuarioDTO = usuarioJSON && JSON.parse(usuarioJSON);
  const esAdmin = usuario?.Rol === 'Administrador';
  const textoBotonSecundario = usuario ? (esAdmin ? 'Dashboard' : 'Mi cuenta') : 'Iniciar sesión';
  const path = usuario ? (esAdmin ? '/admin' : '/usuario') : '/login';

  const onClickSecundario = (path: string) => {
    navigate(path);
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="baseline"
      maxWidth={anchoMaxForms}
      position="relative"
      mx="auto"
    >
      {/* {!subMensaje && (
        <Box width="100%" display="flex" ml={12}>
          <Button fullWidth={false} onClick={onVolver} startIcon={<ChevronLeft />}>
            Volver
          </Button>
        </Box>
      )} */}
      <Box mt={8} marginX="auto" className="pantallaExito">
        <Alerta mensaje={mensaje} abierto severity="success" />
        <Box height="150px" pb={4}>
          <img src={LogoBosch} alt="logo teatro bosch" />
        </Box>
        <Typography variant="h1" mb="25px" fontSize="22px">
          {titulo}
        </Typography>
        <Typography fontWeight={600}>{mensaje}</Typography>
        {subMensaje && (
          <>
            <Typography>{subMensaje}</Typography>
            <Box display="flex" gap={1}>
              <Button sx={{ my: 4, flex: 1 }} onClick={onVolver} variant="contained">
                Volver
              </Button>
              <Button sx={{ my: 4, flex: 1 }} onClick={() => onClickSecundario(path)} variant="outlined">
                {textoBotonSecundario}
              </Button>
            </Box>
          </>
        )}
      </Box>
    </Box>
  );
};

export default PantallaExito;
